<template>
  <div id="listWidget" class="mb-4">
    <div>
      <h4 class="mb-3">{{ props.step }}. 세팅 완료</h4>
      <div class="completion-message mb-3">
        <i class="fa-regular fa-circle-check text-success me-2"></i>
        <span>이관 받기가 완료되었습니다.</span>
      </div>
    </div>

    <!-- ControllerCard 사용 -->
    <ControllerCard
      v-if="props.controller && props.controller._id"
      :controller="props.controller"
      controller-type="조명제어기"
      mode="wizard-complete"
    />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import ControllerCard from '../ControllerCard.vue';

const props = defineProps(['controller', 'step']);
</script>

<style scoped>
.completion-message {
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #495057;
  padding: 0.75rem 0;
}

.completion-message i {
  font-size: 1.5rem;
  color: #198754;
}
</style>
